export default __webpack_public_path__ + "9f822ff20b7d9f4721ea7a9b7044df5e.svg";